import React, { useState, useEffect } from "react";
import TaskForm from "./TaskForm";
import TodoList from "./TodoList";
import "../styles/TodoApp.css";

const TodoApp = () => {
  const getStoredTodos = () => JSON.parse(localStorage.getItem("todos") || "[]");

  const [todos, setTodos] = useState(getStoredTodos);

  useEffect(() => {
    localStorage.setItem("todos", JSON.stringify(todos));
  }, [todos]);

  const addTodo = (task) => {
    const newTodo = { id: Date.now(), task, completed: false, pinned: false };
    setTodos((prev) => [...prev, newTodo]);
  };

  const handleUpdate = (id, updatedFields) => {
    setTodos((prev) =>
      prev.map((todo) => (todo.id === id ? { ...todo, ...updatedFields } : todo))
    );
  };

  const handleDelete = (id) => {
    setTodos((prev) => prev.filter((todo) => todo.id !== id));
  };

  const sortedTodos = [...todos].sort((a, b) => b.pinned - a.pinned);

  return (
    <div className="todo-app-container">
      <h2 className="text-center my-4">Quản lý công việc </h2>
      <div className="form-list-container">
        <TaskForm onSubmit={addTodo} placeholder="Thêm Công Việc" buttonText="Thêm" />
        {todos.length > 0 ? (
          <TodoList todos={sortedTodos} updateTodo={handleUpdate} deleteTodo={handleDelete} />
        ) : (
          <p className="text-center mt-3">Chưa có công việc nào!</p>
        )}
      </div>
    </div>
  );
};

export default TodoApp;
